import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]";
import { type LogoutResponse } from "shared/api/types/society/[societyId]/profiles/[profileId]/logout";
export const postSocietyProfileLogoutContract: BaseApiContract<
  SocietyProfileParamsInput,
  undefined,
  LogoutResponse
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/profiles/[profileId]/logout",
  paramsType: {} as SocietyProfileParamsInput,
  responseType: {} as LogoutResponse,
};
